module.exports = __webpack_public_path__ + "static/media/icons-steps.ab423288.svg";